var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDgb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dgb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RenBridge_v2-icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dgb-icon",
    transform: "translate(-3.000000, -3.000000)",
    fill: "#0063CF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.9705627 16.9705627,21 12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 Z M13.0756664,6.47463457 L11.8916595,6.47463457 L11.5202064,7.44969905 L7.80567498,7.44969905 C7.63542562,7.44969905 7.48065348,7.54256234 7.3955288,7.68185727 L6.46689596,9.31470335 L13.4084265,9.31470335 C13.6405847,9.31470335 13.8650043,9.361135 14.0816853,9.44625967 C14.4918315,9.61650903 14.9716251,9.99570077 14.855546,10.8546862 C14.6543422,12.2940671 13.1840069,14.8400688 10.0034394,14.8787618 L11.6440241,10.5993121 C11.7059329,10.4213242 11.5821152,10.2355976 11.3963887,10.2355976 L9.19088564,10.2355976 L6.52880482,16.7824592 C6.52880482,16.7824592 7.0627687,16.844368 7.91401548,16.844368 L7.65090284,17.533104 L8.86586414,17.533104 C8.96646604,17.533104 9.05159071,17.4711952 9.09028375,17.3860705 L9.32244196,16.7901978 C9.50042992,16.7747206 9.68615649,16.7592433 9.87188306,16.7360275 L9.56233878,17.533104 L10.7618229,17.533104 C10.8624248,17.533104 10.9475494,17.4711952 10.9862425,17.3860705 L11.3344798,16.4806535 C13.3233018,16.0318143 15.4746346,15.0412726 16.7437661,12.9518487 C19.2820292,8.75752365 16.6122098,7.66638005 14.7626827,7.48065348 L15.0799656,6.65262253 C15.11092,6.56749785 15.0490112,6.47463457 14.9638865,6.47463457 L13.7798796,6.47463457 L13.4084265,7.44969905 L12.8822012,7.44969905 L13.1917455,6.65262253 C13.2226999,6.56749785 13.1607911,6.47463457 13.0756664,6.47463457 Z",
    id: "dgb"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDgb);
export default __webpack_public_path__ + "static/media/dgb.55fd5db6.svg";
export { ForwardRef as ReactComponent };